import { Component, Input } from '@angular/core';
import { marked } from 'marked';
import { ChatAnswerResponse } from '../../../models/chat-response.model';

@Component({
  selector: 'lib-chat-answer-response-message',
  templateUrl: './chat-answer-response-message.component.html',
  styleUrls: ['./chat-answer-response-message.component.scss'],
  standalone: false
})
export class ChatAnswerResponseMessageComponent {
  @Input() response!: ChatAnswerResponse;

  renderMarkdown(text: string): string {
    return marked.parse(text, {
      async: false,
      breaks: true,
      gfm: true
    });
  }
}
